export const truncatedCopy = (copy, maxLength) => {
  if (!copy) return;
  if (copy.length <= maxLength) return copy;

  return `${copy.slice(0, maxLength - 3)}...`;
};
